/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { Component, OnInit } from '@angular/core';
import { FileSharingServiceService } from 'src/app/services/file-sharing/file-sharing-service.service';
import { File } from 'src/app/models/file-sharing';

/**
 * An head start on https://jira.wrs.com/browse/IDWNDSHARE-1524
 */
@Component({
  selector: 'wsn-file-sharing',
  templateUrl: './file-sharing.component.html',
  styleUrls: ['./file-sharing.component.scss']
})
export class FileSharingComponent implements OnInit {
  currentPath: string;
  currentChildren: File[];

  constructor(private fileSharingService: FileSharingServiceService) {}

  ngOnInit(): void {
    const d = this.fileSharingService.getDefaultFile();
    this.currentPath = d.path;
    this.currentChildren = this.fileSharingService.getChildren(d.name);
  }

  onHome() {}

  onFile(filename: string) {
    const file = this.fileSharingService.getFile(filename);
    if (file.isDirectory) {
      this.currentPath = file.path;
      this.currentChildren = this.fileSharingService.getChildren(file.name);
    }
  }

  toggleSelection(filename: string) {
    const file = this.fileSharingService.getFile(filename);
    file.selected = !file.selected;
  }

  toggleFavorite(filename: string) {
    const file = this.fileSharingService.getFile(filename);
    file.favorite = !file.favorite;
  }

  onUpload() {}

  onNewFolder() {}

  onNewFile() {}
}
